class HttpFeasibility {
    checkStatus(response) {
        switch (response.status) {
            case 200:
            case 204:
            case 210:
                //console.log('Conexión corecta', response.status);
                break;
            default:
                throw new Error(`${response.status} - ${response.statusText}!`);

        }
    }

    //Buscar Factibilidad
    async searchFeasibility(criteria) {
        let datos;

        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factibilidad/consultar`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(criteria)
        })
            .then(response => {
                this.checkStatus(response);
                return response.json();
            })
            .then(data => {
                datos = data;
            })
            .catch((error) => {
                datos = { "existe": false, "contenido": error.toString() };
            });
        return datos;
    }

    //Listar Factibilidad
     async listFeasibility() {
        let datos;

        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factibilidad/listar`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                this.checkStatus(response);
                return response.json();
            })
            .then(data => {
                datos = data;
            })
            .catch((error) => {
                datos = { "existe": false, "contenido": error.toString() };
            });
        return datos;
    }

    //Crear Factibilidad
     async createFeasibility(data_json) {
        let datos;

        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factibilidad/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data_json)
        })
            .then(response => {
                this.checkStatus(response);
                return response.json();
            })
            .then(data => {
                datos = data;
            })
            .catch((error) => {
                datos = { "existe": false, "contenido": error.toString() };
            });
        return datos;
    }

    //Guardar Contrato de Confidencialidad
     async confidentialityContract(data_json) {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factibilidad/subecontrato`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: data_json
        })
            .then(response => {
                this.checkStatus(response);
                return response.json();
            })
            .then(data => {
                datos = data;
            })
            .catch((error) => {
                datos = { "existe": false, "contenido": error.toString() };
            });
        return datos;
    }

    //Guardar Cuestionario de Factibilidad
    async sendQuestionaryFeasibility(data_json) {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factibilidad/subecuestionario`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data_json)
        })
            .then(response => {
                this.checkStatus(response);
                return response.json();
            })
            .then(data => {
                datos = data;
            })
            .catch((error) => {
                datos = { "existe": false, "contenido": error.toString() };
            });
        return datos;
    }

    //Guardar Visita de Calificación
    async sendQuestionaryFeasibility(data_json) {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factibilidad/subevisita`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data_json)
        })
            .then(response => {
                this.checkStatus(response);
                return response.json();
            })
            .then(data => {
                datos = data;
            })
            .catch((error) => {
                datos = { "existe": false, "contenido": error.toString() };
            });
        return datos;
    }

}

export default new HttpFeasibility();